import { render, staticRenderFns } from "./VerifyIcon.vue?vue&type=template&id=77caa3d6&"
import script from "./VerifyIcon.vue?vue&type=script&lang=ts&"
export * from "./VerifyIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77caa3d6')) {
      api.createRecord('77caa3d6', component.options)
    } else {
      api.reload('77caa3d6', component.options)
    }
    module.hot.accept("./VerifyIcon.vue?vue&type=template&id=77caa3d6&", function () {
      api.rerender('77caa3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/utils/VerifyIcon.vue"
export default component.exports